export const Messages = {
  NO_PROVIDER_OR_EMERGENCY_CONTACT:
    'No contacts or callback locations were found. Please enter them manually to continue.',
};
